import { Center, Stack, Title, Text, Button, Paper } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';

export interface PermissionErrorProps {
	title?: string;
	message?: string;
	details?: string;
	actionLabel?: string;
	onAction?: () => void;
}

export function PermissionError({
	title = 'Access Denied',
	message = 'You do not have permission to view this page',
	details,
	actionLabel = 'Go Back',
	onAction,
}: PermissionErrorProps) {
	return (
		<Center style={{ height: '100%', minHeight: 400 }}>
			<Paper p="lg" radius="md" withBorder style={{ maxWidth: 400, width: '100%' }}>
				<Stack align="center" gap="md">
					<IconLock
						size={48}
						stroke={1.5}
						style={{ color: 'var(--mantine-color-red-6)' }}
					/>

					<Stack align="center" gap="xs">
						<Title order={3} ta="center">
							{title}
						</Title>
						<Text size="sm" c="dimmed" ta="center">
							{message}
						</Text>
						{details && (
							<Text size="xs" c="dimmed" ta="center" mt={4}>
								{details}
							</Text>
						)}
					</Stack>

					{onAction && (
						<Button variant="subtle" size="sm" onClick={onAction}>
							{actionLabel}
						</Button>
					)}
				</Stack>
			</Paper>
		</Center>
	);
}
